import { TblCol } from '../../../../core/table/table.types';
import { tblSpecAddColumn } from '../../../../core/table/spec';
import { TblViewSpec } from '../../../../core/table/table-view.types';
import FormattedDateWithAMPMTimeRenderer from '../../../../core/table/renderers/FormattedDateWithAMPMTimeRenderer';

export type ProcessingErrorsColKey = '' | 'Status' | 'EventType' | 'Entity' | 'Logtime' | 'Details' | 'AlertSentStatus';

export function processingErrorsColumnSpec(isVerity = false): Map<ProcessingErrorsColKey, TblCol> {
    const map = new Map<ProcessingErrorsColKey, TblCol>();
    if (isVerity) {
        tblSpecAddColumn<ProcessingErrorsColKey>(map, 'Status', { title: 'Status' });
    }
    tblSpecAddColumn<ProcessingErrorsColKey>(map, 'EventType', { title: 'Type' });
    tblSpecAddColumn<ProcessingErrorsColKey>(map, 'Entity', { title: 'Entity' });
    tblSpecAddColumn<ProcessingErrorsColKey>(
        map,
        'Logtime',
        { title: 'Logtime', type: 'DATE' },
        FormattedDateWithAMPMTimeRenderer,
    );
    tblSpecAddColumn<ProcessingErrorsColKey>(map, 'Details', { title: 'Details' });
    if (isVerity) {
        tblSpecAddColumn<ProcessingErrorsColKey>(map, 'AlertSentStatus', { title: 'Alert Sent' });
    }
    return map;
}

export function processingErrorsDefaultView(isVerity = false): TblViewSpec {
    if (isVerity) {
        return {
            key: '0',
            title: 'Default',
            sections: [
                { title: 'Event', cols: ['Status', 'EventType'] },
                { title: 'Details', cols: ['Entity', 'Logtime', 'Details'] },
                { title: 'Alert Sent', cols: ['AlertSentStatus'] },
            ],
            sortby: '-Logtime',
        };
    }
    return {
        key: '0',
        title: 'Default',
        sections: [
            {
                title: 'Event',
                cols: ['EventType'],
            },
            {
                title: 'Info',
                cols: ['Entity', 'Logtime', 'Details'],
            },
        ],
        sortby: '-Logtime',
    };
}
